// extracted by mini-css-extract-plugin
export default {"clock":"clockDisplay_clock__NxOtf"};